import _objectSpread from "/home/eletter/.jenkins/workspace/eletter_release/h5/platform/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 初始请求省份数据
//选择省份之后，若本地无数据，则请求城市数据
import { mapState, mapMutations } from 'vuex';
export default {
  name: "selectCityChose",
  props: {
    province: {
      type: String,
      require: false
    },
    city: {
      type: String,
      require: false
    },
    country: {
      type: String,
      require: false
    },
    width: {
      type: Number,
      default: 117,
      require: false
    },
    routefrom: {
      type: String,
      require: false
    },
    brcId: {
      type: String,
      require: false
    },
    unlimiteLevel: {
      //不限区域等级 ，等级3（区）不限 ，等级2（市）不限，市不限包含区不限
      type: Number,
      require: false,
      default: 4
    }
  },
  watch: {
    province: {
      immediate: true,
      handler: function handler(val) {
        this.curProvince = val;
      },
      deep: true
    },
    city: {
      immediate: true,
      handler: function handler(val) {
        this.curCity = val;
      }
    },
    country: {
      immediate: true,
      handler: function handler(val) {
        if (val == '不限') {} else {
          this.curCountry = val;
        }
      }
    },
    routefrom: {
      immediate: true,
      handler: function handler(val) {
        if (val && val.indexOf('check') != -1) {
          this.$set(this.areaDis, 'disabledP', true);
          this.$set(this.areaDis, 'disabledC', true);
          this.$set(this.areaDis, 'disabledCo', true);
        } else {
          this.$set(this.areaDis, 'disabledP', false);
          this.$set(this.areaDis, 'disabledC', false);
          this.$set(this.areaDis, 'disabledCo', false);
        }
      }
    },
    brcId: {
      immediate: true,
      handler: function handler(a) {
        if (a) {
          var tem = a.split('_');

          if (tem.length >= 1) {
            this.$set(this.curPagebrcId, 'pribrcId', tem[0]);
            this.cityList = [];
          }

          if (tem.length >= 2 && tem[1] != '000000') {
            this.$set(this.curPagebrcId, 'citbrcId', tem[1]);
            this.countryList = [];
          }

          if (tem.length >= 3 && tem[2] != '000000') {
            this.$set(this.curPagebrcId, 'coubrcId', tem[2]);
          }
        }
      }
    }
  },
  data: function data() {
    return {
      areaDis: {
        disabledP: false,
        disabledC: false,
        disabledCo: false
      },
      curPagebrcId: {},
      curProvince: '',
      curCity: '',
      curCountry: '',
      orginList: [],
      provinceList: [],
      cityList: [],
      countryList: [],
      targetArea: {
        targetP: 0,
        targetCity: 0,
        targetCo: 0
      }
    };
  },
  computed: _objectSpread({}, mapState(['area'])),
  // watch:{
  // 	province(val, old){
  // 		this.curProvince = val;
  // 	},
  // 	city(val, old){
  // 		this.curCity = val;
  // 	},
  // 	country(val, old){
  // 		this.curCountry = val;
  // 	},
  // },
  mounted: function mounted() {
    var _this = this;

    if (this.area && this.area.brcId) {
      var result = this.area.brcId.split('_');

      if (result.length >= 1) {
        this.curProvince = this.area.province;
        this.curPagebrcId.pribrcId = result[0];

        if (result.length >= 2 && result[1] != '000000') {
          this.curCity = this.area.city;
          this.curPagebrcId.citbrcId = result[1];
        }

        if (result.length >= 3 && result[2] != '000000') {
          this.curCountry = this.area.country;
          this.curPagebrcId.coubrcId = result[2];
        }
      }
    }

    if (this.userInfo.sonFlag == 1 || this.userInfo.channel != '0000') {
      var _result = this.userInfo.brcId.split('_');

      if (_result.length >= 1) {
        this.$set(this.areaDis, 'disabledP', true);
      }

      if (_result.length >= 2 && _result[1] != '000000') {
        this.$set(this.areaDis, 'disabledC', true);
      }

      if (_result.length >= 3 && _result[2] != '000000') {
        this.$set(this.areaDis, 'disabledCo', true);
      }
    }

    this.requestArea({
      level: 1
    }).then(function (data) {
      _this.provinceList = data;
      _this.orginList = _this.provinceList;
    });
  },
  methods: {
    provinceVis: function provinceVis(value) {
      var _this2 = this;

      if (value && this.orginList.length == 0) {
        this.requestArea({
          level: 1
        }).then(function (data) {
          _this2.provinceList = data;
          _this2.orginList = _this2.provinceList;
        });
      }
    },
    provinceChange: function provinceChange(value) {
      var _this3 = this;

      this.targetArea.targetP = this.backIndex(this.provinceList, value);
      var index = this.targetArea.targetP;
      var dataList = {
        name: value.name,
        brcId: value.bcrId
      };
      this.curProvince = value.name;
      this.$emit("updata:province", value.name);
      this.$emit("provinceChange", dataList); //  this.unlimiteLevel >= 2  表示市，区都可选择不限 

      switch (this.unlimiteLevel) {
        case 2:
          this.$emit("updata:city", "不限");
          this.$emit("cityChange", {
            name: "不限",
            brcId: "000000"
          });
          this.curCity = "不限";

        case 3:
          this.$emit("updata:country", "不限");
          this.$emit("countryChange", {
            name: "不限",
            brcId: "000000"
          });
          this.curCountry = "不限";
      }

      this.countryList = [];

      if (typeof this.orginList[this.targetArea.targetP].children == "undefined") {
        this.requestArea({
          level: 2,
          pId: this.orginList[this.targetArea.targetP].bcrId
        }).then(function (data) {
          _this3.cityList = data;

          if (_this3.unlimiteLevel <= 2) {
            _this3.cityList.unshift({
              bcrId: "000000",
              level: "0",
              name: "不限",
              pid: "000000"
            });
          }

          _this3.orginList[_this3.targetArea.targetP]["children"] = _this3.cityList;

          _this3.cityChange({
            name: _this3.cityList[0].name,
            bcrId: _this3.cityList[0].bcrId
          });
        });
      } else {
        this.cityList = this.orginList[index].children;
        this.cityChange({
          name: this.cityList[0].name,
          bcrId: this.cityList[0].bcrId
        });
      }
    },
    cityChange: function cityChange(value) {
      var _this4 = this;

      this.targetArea.targetCity = this.backIndex(this.cityList, value);
      var dataList = {
        name: value.name,
        brcId: value.bcrId
      };
      this.curCity = value.name;
      this.$emit("updata:city", value.name);
      this.$emit("cityChange", dataList);

      if (this.unlimiteLevel <= 3) {
        this.$emit("updata:country", "不限");
        this.$emit("countryChange", {
          name: "不限",
          brcId: "000000"
        });
      }

      var index = this.targetArea.targetCity;

      if (typeof this.orginList[this.targetArea.targetP].children[index].children == "undefined") {
        this.requestArea({
          level: 3,
          pId: this.orginList[this.targetArea.targetP].children[this.targetArea.targetCity].bcrId
        }).then(function (data) {
          _this4.countryList = data;

          if (_this4.unlimiteLevel <= 3) {
            _this4.countryList.unshift({
              bcrId: "000000",
              level: "0",
              name: "不限",
              pid: "000000"
            });
          }

          _this4.orginList[_this4.targetArea.targetP].children[_this4.targetArea.targetCity]["children"] = _this4.countryList;

          _this4.countryChange({
            name: _this4.countryList[0].name,
            bcrId: _this4.countryList[0].bcrId
          });
        });
      } else {
        this.countryList = this.orginList[this.targetArea.targetP].children[index]["children"];
        this.countryChange({
          name: this.countryList[0].name,
          bcrId: this.countryList[0].bcrId
        });
      }
    },
    cityVisibleChange: function cityVisibleChange(value) {
      var _this5 = this;

      if (value) {
        if (this.curProvince == '') {
          this.cityList = [];
          return;
        }

        if (this.cityList.length == 0) {
          if (typeof this.curPagebrcId.pribrcId != 'undefined' && this.curPagebrcId.pribrcId != '000000') this.requestArea({
            level: 2,
            pId: this.curPagebrcId.pribrcId
          }).then(function (data) {
            _this5.cityList = data;

            if (_this5.unlimiteLevel <= 2) {
              _this5.cityList.unshift({
                bcrId: "000000",
                level: "0",
                name: "不限",
                pid: "000000"
              });
            }

            _this5.orginList.forEach(function (item, index) {
              if (item.bcrId == _this5.curPagebrcId.pribrcId) {
                _this5.targetArea.targetP = index;
                item['children'] = _this5.cityList;
              }
            });
          });
        }
      }
    },
    countryVisibleChange: function countryVisibleChange(value) {
      var _this6 = this;

      if (value) {
        if (this.curCity == '') {
          this.countryList = [];
          return;
        }

        if (this.countryList.length == 0) {
          if (typeof this.curPagebrcId.citbrcId != 'undefined' && this.curPagebrcId.citbrcId != '000000') this.requestArea({
            level: 3,
            pId: this.curPagebrcId.citbrcId
          }).then(function (data) {
            _this6.countryList = data;

            if (_this6.unlimiteLevel <= 3) {
              _this6.countryList.unshift({
                bcrId: "000000",
                level: "0",
                name: "不限",
                pid: "000000"
              });
            }

            if (_this6.orginList.length == 0) {
              _this6.orginList.push({
                bcrId: _this6.curPagebrcId.pribrcId,
                level: "1",
                name: _this6.curProvince,
                pid: "100000"
              });

              _this6.targetArea.targetP = 0;
            }

            if (_this6.cityList.length == 0) {
              _this6.targetArea.targetCity = 0;

              _this6.orginList.forEach(function (item, index) {
                if (item.bcrId == _this6.curPagebrcId.citbrcId) {
                  if (item.children.length == 0) {
                    item.children.push({
                      bcrId: _this6.curPagebrcId.citbrcId,
                      level: "2",
                      name: _this6.curCity,
                      pid: _this6.curPagebrcId.pribrcId
                    });
                  }
                }
              });
            }
          });
        }
      }
    },
    countryChange: function countryChange(value) {
      var dataList = {
        name: value.name,
        brcId: value.bcrId
      };
      this.targetArea.targetCo = this.backIndex(this.countryList, value);
      this.$emit("updata:country", value.name);
      this.curCountry = value.name;
      this.$emit("countryChange", dataList);
    },
    requestArea: function requestArea(data) {
      var _this7 = this;

      return new Promise(function (resolve, reject) {
        _this7.requestAPI.areaSearch(data).then(function (res) {
          resolve(res.data.details);
        }).catch(function () {});
      });
    },
    backIndex: function backIndex(data, value) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].bcrId == value.bcrId) {
          return i;
        }
      }
    }
  }
};